<template>
  <div class="app_bar">
    <slot name="head"></slot>
    <div class="app_menu_group">
      <div></div>
      <el-menu
        :default-active="activeIndex"
        class="app_menu"
        mode="horizontal"
        @select="handleSelect"
        router
        v-if="false"
      >
        <template v-for="item in navs">
          <el-menu-item
            class="app_menu-item size-15"
            :index="item.url"
            :key="item.id"
            :class="item.type != 'link' ? 'disabled' : ''"
            style="border-bottom-color: #A50606"
            v-if="item.type != 'tips'"
          >
            {{ $t(item.name) }}
            <div class="float-box">
              <div class="qr_img_group">
                <div class="qr_img_box">
                  <img class="qr_img" src="../../assets/img/android.png" />
                </div>
                <div class="qr_label">
                  <i class="iconfont icon-android"></i>
                  <span class="qr_label_content">{{
                    $t("common_pageText.ANDROIDDOWNLOAD")
                  }}</span>
                </div>
              </div>
              <div class="qr_img_group">
                <div class="qr_img_box">
                  <img class="qr_img" src="../../assets/img/ios.png" />
                </div>
                <div class="qr_label">
                  <i class="iconfont icon-ios"></i>
                  <span class="qr_label_content">{{
                    $t("common_pageText.IOSDOWNLOAD")
                  }}</span>
                </div>
              </div>
            </div>
          </el-menu-item>
        </template>
      </el-menu>
      <slot name="foot"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "NavMenuItem",
  props: ["navs", "activeIndex", "openedIndex"],
  methods: {
    OpenWindow(url) {
      window.open(url, "_blank");
    },
    handleSelect(index, indexPath) {
      this.$store.commit("menu/setOpenedIndex", []);
      this.$store.commit("menu/setActiveIndex", index);
    }
  }
};
</script>
<style scoped>
.app_menu_group {
  display: flex;
  /* font-weight: 700; */
  padding: 0 0 0 0;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}

.app_menu {
  display: block;
  height: 60px;
  line-height: 60px;
  margin: 0 0 0 0;
  border-bottom: 0px;
  box-sizing: border-box;
}
.app_menu > .el-menu-item,
.app_menu-item {
  height: 100%;
  /* height: 60px;
  line-height: 60px; */
  /* background-color: #ffa000; */
  background-color: #c6c6c6;
  /* color: #36383c; */
  color: #fff;
  padding: 0 22.5px;
  border-bottom: 0;
}
.app_menu > .el-menu-item:hover {
  color: #a50606;
  background-color: #c6c6c6;
  border-bottom: 3px solid #a50606;
}
.app_menu > .el-menu-item.disabled:hover {
  /* background-color: #ffa000; */
  color: #a50606;
  background-color: #c6c6c6;
  border-bottom: 3px solid #a50606;
}
.app_menu > .el-menu-item.disabled:hover > .float-box {
  display: flex;
  justify-content: center;
}
.app_menu > .el-menu-item.disabled:focus {
  /* color: #fff; */
}
.app_menu > .el-menu-item.is-active,
.app_menu-item.is-active {
  border-bottom: 0;
  color: #a50606;
  font-weight: 700;
  border-bottom: 3px solid #a50606;
}
.float-group {
  /* position: absolute; */
}
.float-box {
  display: none;
  position: absolute;
  width: 600px;
  height: 350px;
  background-color: #fff;
  z-index: 9999;
  box-shadow: 0px 2px 10px #cfcfcf;
  border-radius: 3px;
  transform: translateX(-45%);
  padding-top: 30px;
  box-sizing: border-box;
}
.float-box::before {
  content: "";
  /* border-width: 6px; */
  /* border-bottom-color: #fff; */
  position: absolute;
  display: block;
  /* border-style: solid; */
  border: 10px solid transparent;
  top: -20px;
  left: 48%;
  border-bottom-color: #fff;
}
.qr_img_group {
  margin: 0 50px;
}
.qr_img_group:first-child {
  margin-right: 0;
}
.qr_img_box {
}
.qr_img {
  width: 200px;
  margin: 10px;
}
.qr_label {
  width: 196px;
  height: 50px;
  line-height: 50px;
  border-radius: 5px;
  border: 2px #8b8b8b solid;
  margin: 10px;
  color: #8b8b8b;
  background-color: #cfcfcf;
  font-weight: normal;
  text-align: center;
  font-size: 17px;
}
.qr_label i.iconfont {
  display: inline-block;
  color: #8b8b8b;
  font-size: 35px;
}
.qr_label_content {
  display: inline-block;
  vertical-align: top;
}
</style>

